<template>
  <div v-if="appStore.loaded && appStore.isFirstLogin"
    class="fixed top-0 left-0 z-9999 w-full h-full bg-[#83e3e1] flex justify-center items-center">
    <Loading show />
    <div class="text-[#fff] absolute top-54px right-54px text-[20px]">
      <van-circle :current-rate="currentRate" :rate="0" size="40px" :clockwise="false" :speed="100" color="#83e3e1"
        :text="`${cutdownTime}`" />
    </div>

  </div>
  <ion-app>
    <LangBtn v-if="isDev" ref="langRef" />
    <ion-router-outlet />
    <!-- <router-view /> -->
  </ion-app>
</template>

<script setup lang="ts">
import { IonApp, IonRouterOutlet, useIonRouter } from '@ionic/vue';
import VConsole from 'vconsole';
import { SplashScreen } from '@capacitor/splash-screen';
import Loading from '@/components/loading/loading.vue';
import { useAppStore, useTokenStore, useUserStore } from '@/store';
import { storage } from '@/plugins/ionic-storage';
import { computed, onMounted, ref, watchEffect } from 'vue';
import { Capacitor } from '@capacitor/core';
import useWsChat from './views/conversation/hooks/useChat';
import { useRoute } from 'vue-router';
// import { inject } from 'vue';
import { liveUpdate } from './plugins/liveUpdate';
import router from '@/router';
import LangBtn from '@/components/LangBtn.vue';

// 注入 Platform 实例
// const platform = inject(Platform)!;
import useDrag from './hooks/useDrag';
import usePageHide from './hooks/usePageHide';
const langRef = ref();
const isDev = ref(import.meta.env.MODE === 'development');

if (isDev.value) {
  useDrag(langRef, {
    initialX: 280,
    initialY: 520,
  });
}


// const router = useIonRouter();
const route = useRoute();

const initialTime = 1;
const appStore = useAppStore();
const userStore = useUserStore();
const isFromAdmin = computed(() => route.query.iframe === 'admin');
if (!isFromAdmin.value) usePageHide();
const cutdownTime = ref(initialTime);
let timer: ReturnType<typeof setTimeout> | null = null;
const cutdownHandle = () => {
  if (cutdownTime.value <= 1) {
    if (timer) clearTimeout(timer);
    timer = null;
    appStore.setInitialLogin(false);
  }
  if (cutdownTime.value > 0) {
    cutdownTime.value--;
    timer = setTimeout(cutdownHandle, 1000);
  }
  console.log('cutdownTime', cutdownTime.value);
};
const currentRate = computed(() => {
  return (cutdownTime.value * 100) / initialTime;
});

watchEffect(() => {
  if (route.query.iframe === 'admin') {
    return appStore.setInitialLogin(false);
  }
  if (appStore.loaded && appStore.isFirstLogin) {
    if (import.meta.env.MODE === 'development') {
      appStore.setInitialLogin(false);
    } else {
      setTimeout(cutdownHandle, 1000);
    }
  }
});

const chat = async () => {
  let {
    token: { accessToken },
  } = useTokenStore();
  accessToken = accessToken || (await storage.get('accessToken'));
  if (accessToken) {
    const { startChat } = useWsChat();
    startChat();
    // userStore.getUnreadMsgCount(); // 获取未读消息数量
  }
};

const appRunning = async () => {
  console.log('appRunning===================');
  if (
    !userStore.user.name ||
    userStore.user.name.toLowerCase() === 'tuantuan'
  ) {
    // router.push('/login');
  } else {
    // 开启 ws 消息
    setTimeout(chat, 300);
  }
  await SplashScreen.hide(); // 隐藏启动屏
};

onMounted(async () => {
  const platformEnv = Capacitor.getPlatform();
  document.body.classList.add('plat-' + platformEnv);
  appRunning();
  if (platformEnv !== 'web') {
    try {
      await liveUpdate(); // 原生需要检查热更新
    } catch (e) {
      console.log('liveUpdate error========', e);
    } finally {
      // appRunning();
    }
  }
});

new VConsole();
</script>
<style>
html,
body,
#app {
  margin: 0;
  padding: 0;
  height: 100%;
  font-size: 32px;
}

* {
  font-family: 'Roboto', sans-serif;
  box-sizing: border-box;
}

body {
  /* 适配刘海屏、异型屏 */
  padding-top: env(safe-area-inset-top);
  /* background: #fff; */
}

/* @import url("https://fonts.googleapis.com/css2?family=Roboto:wght@400;500;700&display=swap"); */

/* :root {
  --ion-color-primary: #6200ee;
  --ion-color-primary-rgb: 98, 0, 238;
  --ion-color-primary-contrast: #ffffff;
  --ion-color-primary-contrast-rgb: 255, 255, 255;
  --ion-color-primary-shade: #8e00ce;
  --ion-color-primary-tint: #a300ff;
  --ion-color-secondary: #3880ff;
  --ion-color-secondary-rgb: 56, 128, 255;
  --ion-color-secondary-contrast: #ffffff;
  --ion-color-secondary-contrast-rgb: 255, 255, 255;
  --ion-color-secondary-shade: #3171e6;
  --ion-color-secondary-tint: #4c8dff;
  --ion-color-tertiary: #7044ff;
  --ion-color-tertiary-rgb: 112, 68, 255;
  --ion-color-tertiary-contrast: #ffffff;
  --ion-color-tertiary-contrast-rgb: 255, 255, 255;
} */
</style>
